import { AxonMark } from "./AxonMark.js";

import { SKILL_REPO_URL, DOCS_URL } from "./Nav.js";

export function FinalCTA() {
  return (
    <section className="ax-cta">
      <div className="ax-cta-inner">
        <div className="ax-cta-mark" aria-hidden>
          <AxonMark size={56} color="var(--at-accent)" />
        </div>

        <h2 className="ax-cta-h">
          Install the skill.<br />
          <span style={{ color: "var(--at-fg-dim)" }}>Keep the keys.</span>
        </h2>

        <div className="ax-cta-install">
          <code>curl -fsSL https://axonterminal.ai/install.sh | bash</code>
        </div>

        <div className="ax-cta-row">
          <a href={SKILL_REPO_URL} target="_blank" rel="noreferrer" className="ax-btn ax-btn-primary ax-btn-lg">
            Get the skill
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M5 12h14M13 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
          <a href={DOCS_URL} target="_blank" rel="noreferrer" className="ax-btn ax-btn-ghost ax-btn-lg">
            Read the docs
          </a>
        </div>

        <div className="ax-cta-bottom">
          <span className="ax-cta-tag">Non-custodial · works in every agent · keys stay local</span>
        </div>
      </div>

      <style>{`
        .ax-cta {
          position: relative;
          padding: 120px 32px 96px;
          text-align: center;
          background:
            radial-gradient(ellipse at center top, rgba(74,222,128,0.08) 0px, transparent 50%),
            var(--at-bg);
          border-top: 1px solid var(--at-hairline);
          overflow: hidden;
        }
        .ax-cta-inner {
          max-width: 720px;
          margin: 0 auto;
          position: relative;
          z-index: 2;
        }
        .ax-cta-mark {
          display: flex; justify-content: center;
          margin-bottom: 28px;
          filter: drop-shadow(0 0 24px rgba(74,222,128,0.3));
        }
        .ax-cta-h {
          font-family: var(--at-font-display);
          font-size: 56px;
          font-weight: 700;
          letter-spacing: -0.028em;
          line-height: 1.05;
          color: var(--at-fg);
          margin: 0 0 40px;
        }
        .ax-cta-install {
          display: inline-block;
          padding: 12px 18px;
          margin: 0 auto 28px;
          background: var(--at-surface);
          border: 1px solid var(--at-hairline);
          border-radius: 8px;
        }
        .ax-cta-install code {
          font-family: var(--at-font-mono);
          font-size: 13px;
          color: var(--at-fg);
          white-space: nowrap;
        }
        @media (max-width: 600px) {
          .ax-cta-install code { font-size: 11px; }
        }
        .ax-cta-row {
          display: inline-flex; gap: 12px; flex-wrap: wrap;
          justify-content: center;
          margin-bottom: 32px;
        }
        .ax-cta-bottom {
          padding-top: 24px;
        }
        .ax-cta-tag {
          font-family: var(--at-font-mono);
          font-size: 11px;
          letter-spacing: 0.25em;
          color: var(--at-muted);
          text-transform: uppercase;
        }

        @media (max-width: 820px) {
          .ax-cta { padding: 72px 20px; }
          .ax-cta-h { font-size: 36px; }
        }
      `}</style>
    </section>
  );
}
